import currencySymbol from "currency-symbol-map";

export default () => ({
  currencySymbol,
});
